import { ActionType, createAction } from 'typesafe-actions';
import { ID } from '../../../types/basic';
import { EmbeddedConfig } from '../../../types/ui';

export const enterLogin = createAction('ENTER_LOGIN')<void>();
export const enterValidation = createAction('ENTER_VALIDATION')<void>();

type EnterStatisticsPayload = {
  queuesIdList: ID[];
  usersIdList: ID[];
  deletedUsersIdList: ID[];
};
export const enterStatistics = createAction(
  'ENTER_STATISTICS',
  (payload: EnterStatisticsPayload) => payload
)<EnterStatisticsPayload>();
export const enterExtensionEditor = createAction(
  'ENTER_EXTENSION_EDITOR'
)<void>();
export const leaveExtensionEditor = createAction(
  'LEAVE_EXTENSION_EDITOR'
)<void>();

export const leaveValidation = createAction('LEAVE_VALIDATION')<void>();

export const startValidation = createAction(
  'START_VALIDATION',
  undefined,
  (url: string, annotationsIds: number[]) => ({ annotationsIds, url })
)<
  undefined,
  {
    url: string;
    annotationsIds: number[];
  }
>();

export const openSelectMenu = createAction('OPEN_SELECT_MENU')<void>();

export const closeSelectMenu = createAction('CLOSE_SELECT_MENU')<void>();

export const startEditMode = createAction('START_EDIT_MODE')<void>();
export const cancelEditMode = createAction(
  'CANCEL_EDIT_MODE',
  (annotationId?: ID) => annotationId
)<ID | undefined>();

export const startEditingDatapointValue = createAction(
  'START_EDITING_DATAPOINT_VALUE'
)<void>();

export const stopEditingDatapointValue = createAction(
  'STOP_EDITING_DATAPOINT_VALUE'
)<void>();

export const toggleFooter = createAction('TOGGLE_FOOTER')<void>();

export const alertNetworkOutage = createAction('ALERT_NETWORK_OUTAGE')<void>();

export const fetchEmbeddedConfigFullfiled = createAction(
  'FETCH_EMBEDDED_CONFIG_FULFILLED',
  (payload: EmbeddedConfig) => payload
)<{
  cancelUrl: string;
  returnUrl: string;
  deleteUrl: string | undefined;
  postponeUrl: string | undefined;
}>();

export type StartValidation = typeof startValidation;

export const setApplicationTabVisibility = createAction(
  'SET_APPLICATION_TAB_VISIBILITY',
  (payload: boolean) => payload
)<boolean>();

export const setGridActionInProgress = createAction(
  'SET_GRID_ACTION_IN_PROGRESS',
  (payload: boolean) => payload
)();

export type UiActions = ActionType<
  | typeof enterLogin
  | typeof enterValidation
  | typeof enterStatistics
  | typeof leaveValidation
  | typeof leaveExtensionEditor
  | StartValidation
  | typeof openSelectMenu
  | typeof closeSelectMenu
  | typeof startEditMode
  | typeof cancelEditMode
  | typeof startEditingDatapointValue
  | typeof stopEditingDatapointValue
  | typeof toggleFooter
  | typeof alertNetworkOutage
  | typeof fetchEmbeddedConfigFullfiled
  | typeof setApplicationTabVisibility
  | typeof setGridActionInProgress
>;
